module.exports = __webpack_public_path__ + "media/3x/S-0267a3a5.png";